<template>
  <div id="app">
    <section :style="bgc_primary">
      <div class="container-fluid">
        <header class="masthead mb-auto">
          <div class="row justify-content-md-center text-center">
            <div class="col-md-5">
              <img :src="settings.logos.main" class="img-fluid" />
            </div>
            <div class="w-100"></div>
            <div class="col-md-7">
              <h1 class="main_title" v-html="$options.filters.translategrader(settings.copy.home_title,lang)">Easy Grader<sup>®</sup> </h1>
            </div>
            <div class="w-100"></div>
            <div class="col-md-7">
              <p class="intro_headline" v-html="$options.filters.translategrader(settings.copy.home_subtitle,lang)">Évaluez votre performance lors d'un quiz</p>
            </div>
          </div>
        </header>
      </div>
    </section>

    <section class="main_section my-4">
      <div class="container-fluid main_container">

        <div class="row justify-content-md-center">
          <div class="col-md-6 text-center">
            <img :src="settings.logos.landing_image" :alt="$options.filters.translategrader(settings.copy.home_title, $i18n.locale)" class="img-fluid p-5 animGif" v-if="$i18n.locale == 'fr'">
            <img :src="settings.logos.landing_image" :alt="$options.filters.translategrader(settings.copy.home_title, $i18n.locale)" class="img-fluid p-5 animGif"  v-if="$i18n.locale == 'en'">
            <img src="@/assets/img/fleche.svg" alt="Start - Content Scoring" class="cta_arrow">
          </div>
          <div class="col-md-6 ">

            <div class="d-flex flex-column">
              <div class="my-4 intro_block">
                <h2 class="subtitle_heading">{{settings.copy.home_section_1_title | translategrader($i18n.locale)}}</h2>
                <div v-html="$options.filters.translategrader(settings.copy.home_section_1_text, $i18n.locale)">
                </div>
              </div>
              <div class="my-4 intro_block">
                <h2 class="subtitle_heading">{{settings.copy.home_section_2_title | translategrader($i18n.locale)}}</h2>
                <div v-html="$options.filters.translategrader(settings.copy.home_section_2_text, $i18n.locale)">
                </div>
              </div>

              <div class="my-4">
                <router-view></router-view>
              </div>

            </div>
          </div>
        </div>

      </div>
    </section>

    <footer-area :settings=settings></footer-area>
  </div>


</template>


<script>

import { mapGetters, mapActions } from 'vuex';
import Footer from '@/components/Footer';

export default {
    name: 'Landing',

    components: {
      FooterArea:Footer
    },

    created() {
      this.getOrCreateSetting();
    },

    methods: {
      ...mapActions({
        getOrCreateSetting: 'settings/getOrCreateSetting',
      })
    },

    computed: {
      ...mapGetters('settings', {
        settings: 'settings'
      }),

      lang : function() {
        return this.$i18n.locale;
      },

      bgc_primary : function() {
        return {backgroundColor: this.settings.colors.primary};
      },

      bgc_secondary : function() {
        return {backgroundColor: this.settings.colors.secondary};
      },
    },
}

</script>


<style>

.bg-dark2{
  background: #051e41;
}

.container {
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
}

.main_container {
  padding-left: 3rem ;
  padding-right: 3rem ;
}

h1.main_title {
  color: var(--colorSecondary);
  font-size: 45px;
  font-family: 'Nunito', sans-serif;
  font-weight: semi-bold;
  margin-top: 10px;
}

.intro_headline {
  color: #fff;
  font-family: 'Nunito', sans-serif;
  font-size: 24px;
  margin: 10px 0 20px;
  font-weight: bold;
}

.intro_block {
  border-left: solid var(--colorSecondary) 4px;
  font-family: 'Nunito', sans-serif;
  padding-left: 17px;
}

.subtitle_heading {
  color: var(--colorSecondary);
  font-family: 'Nunito', sans-serif;
  font-size: 35px;
  line-height: 0.8;
  padding-bottom: 12px;
}
.subtitle_heading_cta {
  color: var(--colorSecondary);
  font-family: 'Nunito', sans-serif;
  font-size: 50px;
}

h2 {
  text-transform: none!important;
}

.detail {
  font-size: 13px;
}

.animGif {
  max-height: 400px;
  margin: 0 auto;
}



/*li{
   list-style: none;
}
li:before{
  content: '';
  display: inline-flex;

  background-image: url('../assets/img/puce.svg');
  background-repeat: no-repeat;
  padding-left: 30px;
  background-position: left center;
  vertical-align: middle;
  height: 24px;
  padding-left: 44px;
  padding-top: 3px;
}

li:after {
  clear:both;
}*/

.cta_arrow {
  width: 200px;
  transform:matrix(0.91,-0.41,0.41,0.91,0,0);
-ms-transform:matrix(0.91,-0.41,0.41,0.91,0,0);
-webkit-transform:matrix(0.91,-0.41,0.41,0.91,0,0);

  position: absolute;
  bottom: 0;
  right: 60px;

}

@media only screen and (max-width: 768px) {
  .cta_arrow {
    display: none;
  }

}

@media only screen and (max-width: 768px) {

  .intro_headline {
    margin-bottom: 40px;
  }

  .main_container {
    padding-left: 1rem ;
    padding-right: 1rem ;
  }

  .cta_arrow {
    transform:matrix(-0.45,0.21,0.21,0.45,20,0);
-ms-transform:matrix(-0.45,0.21,0.21,0.45,20,0);
-webkit-transform:matrix(-0.45,0.21,0.21,0.45,20,0);
    margin-bottom: -20px;
    float: right;
  }

  .subtitle_heading_cta {
    margin-top: -100px;
  }


}


</style>

<style>
@media only screen and (max-width: 768px) {
  footer {
    font-size: 12px;
  }
}

.main_section ul {
  padding-inline-start: 12px;
  padding-left: 12px;
  list-style-image: url('../assets/img/puce.svg');
}
</style>



// WEBPACK FOOTER //
// src/layouts/Landing.vue